import React, {useEffect} from "react";
import {Route, Routes, useNavigate, useLocation} from "react-router-dom";
import {ViewRecordings} from "./Views/ViewRecordings";
import {Authentication} from "./Views/Authentication";
import {useDispatch, useSelector} from "react-redux";
import {getCurrentSpaceThunk} from "./Feature/SpacesSlice";
import {SelectSpace} from "./Views/SelectSpace";
import {SpaceSettings} from "./Views/SpaceSettings";
import {LabelManagement} from "./Views/LabelManagement";
import {SongListPage} from "./Views/SongListPage";
import {SongDetailPage} from "./Views/SongDetailPage";
import {Login} from "./Views/Login";
import {CalendarView} from "./Views/CalendarView";
import AuthLayout from "./Components/AuthLayout";
import {useSpacePersistence} from "./hooks/useSpacePersistence";

export const RouterComponent = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const { saveLastSpaceId, getLastSpaceId } = useSpacePersistence();

    const user = useSelector((state) => {
        return state.firebase.auth
    });

    useEffect(() => {
        const regex = /\/spaces\/([^/]+)/;
        const matches = location.pathname.match(regex);

        if (user && !user.isEmpty) {
            if (matches) {
                const spaceId = matches[1];
                console.log('Loading space:', spaceId);
                dispatch(getCurrentSpaceThunk(spaceId)).unwrap()
                    .then(() => {
                        saveLastSpaceId(spaceId);
                    })
                    .catch(err => {
                        console.error('Error loading space:', err);
                        navigate('/spaces');
                    });
            } else if (location.pathname === '/spaces' || location.pathname === '/spaces/') {
                // User is on space selection page, try to load last visited space
                const lastSpaceId = getLastSpaceId();
                if (lastSpaceId) {
                    console.log('Auto-loading last visited space:', lastSpaceId);
                    dispatch(getCurrentSpaceThunk(lastSpaceId)).unwrap()
                        .then(() => {
                            navigate(`/spaces/${lastSpaceId}/`);
                        })
                        .catch(err => {
                            console.error('Error loading last space:', err);
                            // Fall back to space selection if space no longer exists
                        });
                }
            }
        }
    }, [user, dispatch, location.pathname, navigate, saveLastSpaceId, getLastSpaceId]);

    return (
        <Routes>
            <Route path="/spaces" element={<AuthLayout />}>
                <Route path=":spaceId/recordings" element={<ViewRecordings/>}/>
                <Route path=":spaceId/settings" element={<SpaceSettings/>}/>
                <Route path=":spaceId/labels" element={<LabelManagement/>}/>
                <Route path=":spaceId/songs" element={<SongListPage/>}/>
                <Route path=":spaceId/songs/:songId" element={<SongDetailPage/>}/>
                <Route path=":spaceId/calendar" element={<CalendarView/>}/>
                <Route path=":spaceId/" element={<ViewRecordings/>}/>
                <Route path="" element={<SelectSpace/>}/>
            </Route>
            <Route exact path="/login" element={<Login/>}/>
            <Route  path="/" element={<Authentication/>}/>
        </Routes>
    );
}
